import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TraineeService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getTrainees(userKey: number): Observable<Trainee[]> {
    return this.http.get<Trainee[]>(`${environment.apiUrl}/Trainee/${userKey}`);
  }

  getTraineesBySession(userKey: number, sessionKey: number): Observable<Trainee[]> {
    return this.http.get<Trainee[]>(`${environment.apiUrl}/Trainee/${userKey}/${sessionKey}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addTrainee(trainee: Trainee) {
    return this.http.post(`${environment.apiUrl}/Trainee`, trainee);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateTrainee(trainee: Trainee) {
    return this.http.put(`${environment.apiUrl}/Trainee`, trainee);
  }

}
